import {
  TOrderInputType,
} from './pt9800-loading-place';

const orderInputType: Record<TOrderInputType, string> = {
  keyboard: 'Klávesnica',
  scanner: 'Skener',
};

export default {
  orderInputType,
  orderInputlabel: 'Typ zadávania zákazky',
  loadingPlace: 'Miesto zakladania',
  orderInput: 'Zákazka',
  priority: 'Priorita',
  processFlowNo: 'Č. procesu',
  box: 'Box',
  cellChargeNo: 'Č. vsázky komory',
  comment1: 'Komentár 1',
  comment2: 'Komentár 2',
  comment3: 'Komentár 3',
  placeStatus: 'Stav miesta',
  locked: 'Zablokované',
  loadBookedAndReady: 'Vsázka rezervovaná a pripravená',
  enableLoadForAutomatic: 'Povoliť vsázku pre automatiku',
  loadbookingEnded: 'Rezervácia vsázky ukončená',
  camera: 'Kamera',
  noOrderLoaded: 'Žiadna zákazka nie je načítaná',
};
